__turbopack_context__.v({
  "about": "About-module__eErCCW__about",
  "aboutCallout": "About-module__eErCCW__aboutCallout",
  "aboutCol": "About-module__eErCCW__aboutCol",
  "aboutCopy": "About-module__eErCCW__aboutCopy",
  "aboutHeader": "About-module__eErCCW__aboutHeader",
  "animatedSection": "About-module__eErCCW__animatedSection",
  "backgroundOverlay": "About-module__eErCCW__backgroundOverlay",
  "callout": "About-module__eErCCW__callout",
  "centered": "About-module__eErCCW__centered",
  "imageContainer": "About-module__eErCCW__imageContainer",
  "imageLeft": "About-module__eErCCW__imageLeft",
  "imagePlaceholder": "About-module__eErCCW__imagePlaceholder",
  "imageRight": "About-module__eErCCW__imageRight",
  "parallaxSection": "About-module__eErCCW__parallaxSection",
  "responsiveImage": "About-module__eErCCW__responsiveImage",
  "sectionImage": "About-module__eErCCW__sectionImage",
  "textContainer": "About-module__eErCCW__textContainer",
});
